/**
 * @module Module
 */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Input from "../Input";
import { Text } from "react-internationalization";

const CustomButtonSecondary = withStyles({
  root: {
    backgroundColor: "white",
    borderColor: "#0089cf",
    color: "#0089cf",
    size: "small",
    width: "50px",
    height: "35px",
    "&:hover": {
      backgroundColor: "#707070",
      border: " 2px #222831",
      boxShadow: "none",
      color: "white",
      width: "50px",
      height: "35px",
    },
  },
})(Button);

/**
 *Reusable component used by different components for Popup's.
 * @method Modal
 * @param {object} props props that is being passed by the
 * @returns {JSX} returns Modal jsx.
 */
function Modal(props) {
  const [toggle, setToggle] = React.useState("");
  const [inputEmail, setInputEmail] = React.useState("");

  /**
   * Re renders the component everytime and set's toggle.
   * @function useEffect
   * @returns {void}
   */
  React.useEffect(() => {
    setToggle(props.show);
    /**
     * Re renders the component whenever new props are passed.
     * @function useEffect
     * @returns {void}
     */
    if (props.show) {
      setInputEmail("");
    }
  }, [props.show]);

  const handleChange = (event) => {
    const value = event.target.value;
    setInputEmail(value);
  };

  const handleSendEmail = () => {
    props.sendEmail(inputEmail);
    setInputEmail("");
    props.modalClosed();
  };

  return (
    <Dialog
      className={props.lang === "es" ? "mailDialog" : ""}
      open={props.show && toggle}
      id={props.idName ? props.idName : ""}
    >
      <DialogTitle
        style={{
          padding: props.paddingHeading ? props.paddingHeading : "",
        }}
        className="emailpop-title"
      >
        {props.dialogTitle}
        {props.closeIcon ? (
          <a
            className="float-right cursor-pointer"
            onClick={() => props.modalClosed()}
          >
            <i className="fas fa-times" />
          </a>
        ) : (
          ""
        )}
      </DialogTitle>
      <DialogContent>

        <div>{props.message}</div>
       
        {props.inputField && (
          <div>
            <Input
              autoComplete="off"
              forName={"email"}
              classLabel="control-label"
              label=""
              type="text"
              name="email"
              classInput="form-control borderhighlighted"
              value={inputEmail}
              handleChange={handleChange}
              handleOnBlur={() => {}}
            />
          </div>


        )}
      </DialogContent>

      <DialogActions>
        {props.okButton && (
          <CustomButtonSecondary
            variant="outlined"
            color="primary"
            onClick={() => {
              props.modalClosed("ok");
            }}
          >
            <Text id="app.ok" />
          </CustomButtonSecondary>
        )}
        {props.sendButton && (
          <CustomButtonSecondary
            variant="outlined"
            color="primary"
            onClick={handleSendEmail}
            disabled={inputEmail === "" ? true : false}
          >
            <Text id="app.send" />
          </CustomButtonSecondary>
        )}
        {props.cancelButton && (
          <CustomButtonSecondary
            variant="outlined"
            color="primary"
            onClick={() => {
              props.modalClosed("cancel");
            }}
          >
            <Text id="app.cancel" />
          </CustomButtonSecondary>
        )}
        {props.closeButton && (
          <CustomButtonSecondary
            variant="outlined"
            color="primary"
            onClick={() => {
              props.modalClosed("close");
            }}
          >
            <Text id="app.close" />
          </CustomButtonSecondary>
        )}
        {props.signUpButton && (
          <CustomButtonSecondary
            variant="outlined"
            color="primary"
            onClick={props.signUp}
          >
            <Text id="user.lSignUp" />
          </CustomButtonSecondary>
        )}
      </DialogActions>
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {
    email: state.login.emailAddress,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
